import React from 'react';

export const AccountMenuBubbleContainer = (
  props: React.HTMLProps<HTMLDivElement>,
) => {
  return (
    <div
      {...props}
      className={`
        account-menu-bubble-container
        bg-white w-full rounded-2xl px-6 py-[14px] flex justify-start items-center mb-8 flex-wrap relative z-20
        ${props.className}
      `}
    >
      {props.children && props.children}
    </div>
  );
};

export const DetailItem = (props: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div
      {...props}
      className={`
        detail-item
        flex justify-start items-center leading-8 text-md text-neutral-pencil
        ${props.className}
        [&_span]:ml-auto [&_span]:font-bold [&_span]:text-neutral-pencil
      `}
    >
      {props.children && props.children}
    </div>
  );
};
